

export default {
  name: 'BlogFilterAuthors',
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      activeItems: [],
      filtersAuthorCodes: [],
      isAllFiltersAuthorCodesActive: false
    }
  },
  created() {
    this.handleAuthorFromQueryString()
  },
  mounted() {
  },
  computed: {
    authorCodes () {
      return this.$store.getters['blog/filtersAuthorCodes']
    },
    isAllAuthorCodesActive () {
      return this.authorCodes.length === this.data.length
    },
    // Check if it is in author page. If yes, no show for "All" button
    isInAuthorPage() {
      if(this.$route?.name?.includes("blog-author-slug")) {
        return true
      }
      return false
    },
  },
  methods: {
    saveToStore(value) {
      this.$store.commit('blog/setAuthorCodes', value)
      console.debug('saveToStore()', this.authorCodes)
    },
    saveAllToStore() {
      this.$store.commit('blog/setAllAuthorCodes', this.data.map((item, index) => item.TagCode ))
      console.debug('saveAllToStore()', this.authorCodes)
    },
    handleAuthorClicked(value) {
      if (this.isBlogSinglePage()) {
        this.goToBlogListPage(value)
        return
      }
      
      if (this.isAuthorPage()) {
        this.goToBlogListPage(value)
        return
      }

      if (this.isAllAuthorCodesActive) {
        this.$store.commit('blog/clearAuthorCodes')
        this.saveToStore(value)
        console.debug('handleTagClicked()', value)
      } else {
        this.saveToStore(value)
      }
    },
    handleAuthorFromQueryString() {
      const self = this
      const qs = this.$route?.query?.blog_author_filter
      const authors = qs?.split(',')
      if (qs) {
        this.$store.commit('blog/clearAuthorCodes')
        authors?.forEach(function (el) {
          self.saveToStore(el)
        });
      }
    },
    isAuthorPage() {
      if(this.$route?.name?.includes("blog-author-slug")) {
        return true
      }
      return false
    },
    isBlogSinglePage() {
      if(this.$route?.name?.includes("blog-slug")) {
        return true
      }
      return false
    },
    goToBlogListPage(value) {
      if(value) {
        this.saveToStore(value)
        this.$store.commit('blog/setActiveType', 'AUTHOR')
      } 
      this.$router.push({
          path: `/${this.$i18n.locale}/blog`,
      })
    },
    // If in author page, use this function, so that user can stay in author page after selecting only one author
    goToBlogAuthorPage(value) {
      if(value) {
        this.$store.commit('blog/clearAuthorCodes')
        this.$store.commit('blog/setAuthorCodes', value)
        this.$store.commit('blog/setActiveType', 'AUTHOR')
      }
      this.$router.push({
          path: `/${this.$i18n.locale}/blog/author/${value}`,
      })
    },
  },
}
